import PropTypes from 'prop-types'
import { Box, Text, VStack } from '@chakra-ui/react'
import React, { memo } from 'react'
import { colors } from '../../../utils/theme/styles'

const InfoLabel = ({ title, value }) => {
  return (
    <Box w="100%">
      <VStack w="100%" alignItems="flex-start">
        <Box>
          <Text color={colors.gray[400]} variant="subtitle3">
            {title}
          </Text>
        </Box>
        <Box
          bgColor={colors.gray['50-0']}
          border={`1px solid ${colors.gray[100]}`}
          boxSizing="border-box"
          boxShadow="'0px 1px 2px rgba(55, 65, 81, 0.08)'"
          borderRadius={0}
          w="100%"
          h="36px"
          overflow="hidden"
          whiteSpace="nowrap"
        >
          <Text
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            variant="body1ellipsis"
          >
            {value}
          </Text>
        </Box>
      </VStack>
    </Box>
  )
}

InfoLabel.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
}

export default memo(InfoLabel)
